import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHead } from "@/components/storefront/common";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then(({ data }) => setBrands(data.brands)); }, []);
  return (
    <div className="container-x py-8">
      <PageHead title="Shop by Brand" crumbs={[{ label: "Home", to: "/" }, { label: "Brands" }]} />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {brands.map((b) => (
          <Link key={b.id} to={`/brand/${b.slug}`} data-testid={`brand-card-${b.slug}`}
            className="rounded-xl border border-slate-200 bg-white p-8 flex items-center justify-center hover:border-amber-400 hover:shadow-lg transition group">
            <span className="font-display font-bold text-xl text-slate-800 group-hover:text-amber-600">{b.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
